import { createSelector } from 'reselect'

import { IFormState } from '../models'

export const createValidationMessageSelector = <T = unknown>(formKey: string, fieldName: string) =>
  createSelector(
    (state: { form: IFormState<T> }) => state.form,
    (form) => form[formKey]?.invalidFields[fieldName]
  )
